import React from 'react';
import { useCurrentModule } from '../components';
import { isMobileStickyPlanAndCycleEnabled } from '../utils/isMobileStickyPlanAndCycleEnabled';
import { ECLIPSE_MOBILE_MODULE_NAME } from '../utils/moduleNames';
import { useSwitchFlows } from './useSwitchFlows';
export const CYCLE_RECOMMENDATION_SPEC = 'recommendedCycleTest';
export const CYCLE_RECOMMENDATION_MOBILE_SPEC = 'recommendedCycleMobile';
export const CYCLE_RECOMMENDATION_SHADOW_SPEC = 'recommendedCycleShadow';
export const useCycleRecommendationEnabled = () => {
  const module = useCurrentModule();
  const {
    isQuickPayLightbox
  } = module.internals.useContext();
  const {
    ready,
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const {
    isSwitchFlow,
    isLoading: isSwitchFlowLoading
  } = useSwitchFlows();
  const isMobile = module.moduleName === ECLIPSE_MOBILE_MODULE_NAME;
  const spec = isMobile ? CYCLE_RECOMMENDATION_MOBILE_SPEC : CYCLE_RECOMMENDATION_SPEC;
  const isLoading = ready === false || isSwitchFlowLoading;
  const isSpecEnabled = isMobileStickyPlanAndCycleEnabled({
    experiments,
    isMobile
  }) || experiments.isEnabled(spec);
  const isShadowEnabled = experiments.isEnabled(CYCLE_RECOMMENDATION_SHADOW_SPEC);
  const passesExclusions = !isLoading && isSwitchFlow === false && !isQuickPayLightbox;
  const isEligible = passesExclusions && isSpecEnabled;
  const shouldFetch = passesExclusions && (isSpecEnabled || isShadowEnabled);
  const isShadow = shouldFetch && !isEligible;
  const ineligibleReasons = React.useMemo(() => {
    if (isLoading || isEligible) {
      return [];
    }
    const reasons = [];
    if (!isSpecEnabled) {
      reasons.push('experiment_off');
    }
    if (isQuickPayLightbox) {
      reasons.push('quickpay_lightbox');
    }
    if (isSwitchFlow === true) {
      reasons.push('switch_flow');
    } else if (isSwitchFlow === undefined) {
      reasons.push('switch_flow_unknown');
    }
    return reasons;
  }, [isLoading, isEligible, isSpecEnabled, isQuickPayLightbox, isSwitchFlow]);
  return {
    isEligible,
    shouldFetch,
    isShadow,
    ineligibleReasons,
    isLoading
  };
};
//# sourceMappingURL=useCycleRecommendationEnabled.js.map